export const BASE = {
  version: () => "/",
  login: () => "/v2/login"
};

export const ADMIN = {
  konfigParametry: () => "/v2/admin/konfigparametry",
  smlouva: id => (id ? `/v2/admin/smlouva/${id}` : `/v2/admin/smlouva`),
  projekt: id => (id ? `/v2/admin/projekt/${id}` : `/v2/admin/projekt`),
  zdroje: () => `/v2/admin/zdroje`,
  zdroj: id => (id ? `/v2/admin/zdroj/${id}` : `/v2/admin/zdroj`),
  produkty: () => `/v2/admin/produkty`,
  produkt: id => (id ? `/v2/admin/produkt/${id}` : `/v2/admin/produkt`),
  doplnkoveSluzby: () => `/v2/admin/doplnkovesluzby`,
  doplnkovaSluzba: id =>
    id ? `/v2/admin/doplnkovasluzba/${id}` : `/v2/admin/doplnkovasluzba`
};

export const DATA = {
  zadostiCreate: () => "/v2/data/zadost",
  zadostiExcel: () => "/v2/data/zadosti/excel",
  zadostiFaze: () => "/v2/data/zadosti/faze",
  zadostiFixniNaroky: () => "/v2/data/zadosti/fixninaroky",
  zadostiObsazenost: () => "/v2/data/zadosti/obsazenost",
  dataZadostiSumar: () => "/v2/data/zadosti/sumar",
  dataZadostiSeznam: () => "/v2/data/zadosti/seznam",
  zadostiSeznamHistorie: () => "/v2/data/zadosti/seznam/historie",
  zadost: id => `/v2/data/zadost/${id}`,
  zadostPoznamky: id => `/v2/data/zadost/${id}/poznamky`,
  dataZadostiStavy: () => "/v2/data/zadosti/stavyzadosti",
  konfigParametry: () => "/v2/data/konfigparametry",
  notifikaceUser: user => `/v2/data/notifikace/${user}`,
  notifikace: user => `/v2/data/notifikace`,
  projekty: ico => `/v2/data/zakaznik/${ico}/projekty`,
  provozniInformace: id => {
    const idPath = id !== undefined ? `/${id}` : "";
    return `/v2/data/provozniinformace${idPath}`;
  },
  provozniInformacePosledni: pocet =>
    `/v2/data/provozniinformace/posledni/${pocet}`,
  provozniInformaceSeznam: () => `/v2/data/provozniinformace/seznam`,
  rezervace: () => "/v2/data/rezervace",
  smlouvy: ico => `/v2/data/zakaznik/${ico}/smlouvy`,
  smlouvyNaroky: ico => `/v2/data/zakaznik/${ico}/smlouvy/fixninaroky`,
  uzivatele: ico => `/v2/data/zakaznik/${ico}/uzivatele`,
  zakaznik: ico => `/v2/data/zakaznik/${ico}`,
  zakaznici: () => "/v2/data/zakaznici",
  typyZdroje: () => "/v2/data/zdroj/typyzdroje",
  zadostiPotvrzeni: () => "/v2/data/zadosti/potvrzeni",
  zadostiZamitnuti: () => "/v2/data/zadosti/zamitnuti"
};

export const FILES = {
  provozniInformace: key => `/v2/data/provozniinformace/soubor/${key}`
};

export const UZIVATEL = {
  userInfo: () => "/v2/uzivatel",
  userLang: () => "/v2/uzivatel/jazyk"
};
